export type WorkspaceInvariantOptions = {
  source?: string;
};

/**
 * 書き込み系の「誤保存」を止める最後の砦。
 *
 * 期待する不変条件:
 * - 現在のURLパス（pathname）が `/${workspaceId}` または `/${workspaceId}/...` で始まること
 *
 * 一致しない場合は例外を投げ、上位でUIにエラー表示/中断させる。
 */
export function assertWorkspaceInvariant(workspaceId: string, opts?: WorkspaceInvariantOptions): void {
  const ws = String(workspaceId ?? '').trim();
  const source = opts?.source ? String(opts.source) : 'unknown';

  if (!ws) {
    throw new Error(`[workspace-invariant] missing workspaceId (source=${source})`);
  }

  // SSR等ではチェック不能なのでスキップ（このアプリは基本クライアント実行）
  if (typeof window === 'undefined') return;

  const pathname = String(window.location?.pathname || '');
  const ok = pathname === `/${ws}` || pathname.startsWith(`/${ws}/`);
  if (!ok) {
    throw new Error(
      `[workspace-invariant] workspaceId mismatch (source=${source}) expectedPathPrefix=/${ws} actualPath=${pathname}`
    );
  }
}

